module.exports = __webpack_public_path__ + "static/media/4.889fd0e8.jpg";